import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ScreenDetectedService } from 'src/app/core/services/screen-detected.service';
import { TypeDevice } from '../enums/type-device.enum';

@Directive({
  selector: '[screen]'
})
export class ScreenDirective {

  constructor(private templateRef: TemplateRef<any>, 
    private viewContainer: ViewContainerRef,
    private ss: ScreenDetectedService) {  }

    @Input() set screen(type: TypeDevice) {

      if (type === this.ss.geTypeDevice() || type === TypeDevice.all) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
      
  }

}

// *screen=0 - PC, *screen=1 - MOBILE, *screen=2 - BOTH